import { Box } from "@mui/material";
import { NonNullableDate } from "../../../../../../../../../utils/date-time-utility";
import {
  DEFAULT_BG_COLOR,
  DEFAULT_KEY_LABEL_COLOR,
  DEFAULT_LABEL_COLOR,
  getValueFromObj,
} from "../../../../../../../../../utils/utils";
import Text from "../../../../../../../../../components/Text";

const MedicationRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "110px 8px 1fr",
      alignItems: "start",
    }}
  >
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>{label}</Text>
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>:</Text>
    <Text sx={{ color: "#222", wordBreak: "break-word" }}>{value}</Text>
  </Box>
);

interface MedicationData {
  medicationStartDate: Date | undefined;
  uuid: string;
  patient: Record<string, string>;
  medicalCodes: Record<string, string>;
  prescribedBy: Record<string, string>;
  note: string;
  active: boolean;
  archive: boolean;
  recordedDate: Date;
  modifiedDate: Date;
  appointmentId: string | null;
  providerStatus: string | null;
}
export const MedicationTooltip: React.FC<{ data: MedicationData }> = ({
  data,
}) => (
  <Box sx={{ minWidth: 250 }}>
    {/* Title Bar */}
    <Box
      sx={{
        background: DEFAULT_BG_COLOR,
        padding: "8px 12px",
      }}
    >
      <Text color={DEFAULT_LABEL_COLOR}>Medication Details</Text>
    </Box>
    {/* Content */}
    <Box
      sx={{
        padding: "12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <MedicationRow
        label="Medication"
        value={getValueFromObj(data?.medicalCodes)}
      />
      <MedicationRow
        label="Date"
        value={NonNullableDate(data?.medicationStartDate)}
      />
      <MedicationRow
        label="Status"
        value={data?.active ? "Active" : "Inactive"}
      />
      <MedicationRow label="Note" value={data?.note} />
    </Box>
  </Box>
);
